import { useApp } from "@/App";
import { motion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";

export default function LocationSelector() {
  const { setSelectedLocation, locations } = useApp();

  const branches = [
    {
      slug: "cestlice",
      name: "CAR SPA",
      subtitle: "Čestlice",
      address: "Pražská 138, Aquapalace Praha",
      image: "https://images.unsplash.com/photo-1742702596008-5a02e0a8ad49?q=85&w=1200&auto=format&fit=crop",
      glowClass: "green",
    },
    {
      slug: "butovice",
      name: "CAR SPA",
      subtitle: "Butovice",
      address: "Coral Office Park, Bucharova 8, Praha 5",
      image: "https://images.unsplash.com/photo-1769641240978-fff8b96d3b42?q=85&w=1200&auto=format&fit=crop",
      glowClass: "white",
    },
  ];

  return (
    <div className="h-screen w-screen flex flex-col md:flex-row overflow-hidden bg-[#050505]" data-testid="location-selector">
      {/* Subtitle */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.6 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 text-center"
      >
        <p className="text-xs tracking-[0.2em] uppercase text-zinc-600">
          Vyberte pobočku
        </p>
      </motion.div>

      {branches.map((branch, index) => (
        <motion.div
          key={branch.slug}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: index * 0.2 }}
          className={`location-card ${branch.glowClass} relative flex-1 cursor-pointer group flex items-center justify-center`}
          onClick={() => setSelectedLocation(branch.slug)}
          data-testid={`location-${branch.slug}`}
        >
          {/* Background image */}
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
            style={{ backgroundImage: `url(${branch.image})` }}
          />

          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/70 group-hover:bg-black/55 transition-colors duration-500" />

          {/* Divider line removed - using center CAR SPA divider */}

          {/* Content */}
          <div className="relative z-10 text-center px-8">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
            >
              <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#39FF14] mb-4">
                Car Spa
              </p>

              <h2 className="text-4xl md:text-6xl font-black tracking-tighter uppercase text-white mb-2 group-hover:text-[#39FF14] transition-colors duration-300">
                {branch.subtitle}
              </h2>

              <div className="flex items-center justify-center gap-2 mt-4 text-zinc-400 group-hover:text-zinc-300 transition-colors duration-300">
                <MapPin className="w-4 h-4" />
                <span className="text-sm">{branch.address}</span>
              </div>

              <div className="mt-8 flex items-center justify-center gap-2 text-white/0 group-hover:text-[#39FF14] transition-colors duration-500">
                <span className="text-sm font-bold tracking-wider uppercase">Vstoupit</span>
                <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
              </div>
            </motion.div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
